import Cookies from "js-cookie";
import {CurrentUser} from "../Hooks/currentUser";
import {useNavigate} from "react-router-dom";

export function IsAuthnticated() {
    
     let exp_time = Cookies.get("ut") ?? 0;
    if (Math.round(Date.now() / 1000) > parseInt(exp_time)) {
        return false;
    }
    return true;
}

export function CanAccess(access) {
     try {
        const role = CurrentUser()?.Role;
        
        if (Array.isArray(access)) {
            if (access.includes(role))
                return true
        } else {

            if (access == role) return true;
        }

        switch (role) {
            
            case access:
                return true;
                break;
            default:
                return false;
        }
    } catch (e) {

        window.location.assign("/login");
        
    }
}
